import styled from "styled-components";

import { SmallText } from "../../../base/Content";

export const PatientSearchResultsDescription = styled(SmallText)`
  padding: 10px 0px;
`;
